import React from 'react'
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next'
import Timestamp from '../components/Timestamp';
import resumeData from '../data/resume.json';

const ExperienceItem = ({ item }) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <div className="mt-4">
      <h4 className="text-lg font-bold">{t(item.title)}</h4>
      {item.company && (
        <p className="text-secondary">
          {item.company}, {item.location}
        </p>
      )}
      <p className="text-secondary">{item.period[currentLang]}</p>
      <ul className="list-disc list-inside text-primary">
        {item.responsibilities[currentLang]?.map((resp, index) => (
          <li key={index}>{resp}</li>
        ))}
      </ul>
    </div>
  );
};

const EducationItem = ({ item }) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <div className="mt-4">
      <h4 className="text-lg font-bold">{t(item.title)}</h4>
      <p className="text-secondary">
        {t(item.institution)}
        {item.location && `, ${item.location}`}
      </p>
      <p className="text-secondary">{item.period[currentLang]}</p>
      <p className="text-primary">
        {item.description[currentLang]}
        {item.hasLink && (
          <a
            href={t("education_link")}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            {t("see_more_education")}
          </a>
        )}
      </p>
    </div>
  );
};

const ResumeSection = () => {
  const { t, i18n } = useTranslation();

  const handleDownload = () => {
    const cvUrl = i18n.language === 'de' 
      ? 'https://drive.google.com/uc?export=download&id=1uQ4iIYfA0GpqVFxHNnct6mYk2gc2sRuU'
      : 'https://drive.google.com/uc?export=download&id=1INWm4UDGPl1S0XpY3mCTUfoD_KgUTM8_';
    
    const link = document.createElement('a');
    link.href = cvUrl;
    link.download = i18n.language === 'de' ? 'Lebenslauf.pdf' : 'CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="flex relative justify-center px-4 py-8 bg-grid-dots bg-dot-pattern sm:px-8 scroll-mt-16" id='resume'>
      {/* Main Content */}
      <div className="flex flex-col p-6 w-full max-w-6xl h-full rounded-md border-2 shadow-lg bg-background sm:p-8">
        {/* Resume Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-3xl font-bold sm:text-4xl">{t("resume")}</h2>
            <Timestamp />
          </div>
          <button 
            onClick={handleDownload}
            className="flex items-center px-4 py-2 space-x-2 text-white bg-blue-500 rounded-lg transition hover:bg-blue-600"
          >
            <DownloadIcon />
            <span>{t("download pdf")}</span>
          </button>
        </div>

        {/* Experience Section */}
        <div className="mb-6">
          <h3 className="text-xl font-bold text-secondary">{t("experience")}</h3>
          {resumeData.experience.map((exp, index) => (
            <ExperienceItem key={index} item={exp} />
          ))}
        </div>

        {/* Education Section */}
        <div>
          <h3 className="text-xl font-bold text-gray-600">{t("education")}</h3>
          {resumeData.education.map((edu, index) => (
            <EducationItem key={index} item={edu} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default ResumeSection